module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('router-link', {
    attrs: {
      "to": "game"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("play_arrow")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Play")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "settings"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("settings")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Settings")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "score"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "src": require("../assets/leaderboard.svg"),
      "title": "Leaderboard",
      "width": "28.8"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Score")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c24d0f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 37
// module chunks = 0